// constants.js

const useConstants = () => {
  const per_page = 10;
  const sql_date_format = "YYYY-MM-DD";
  const items_per_page_options = [5, 10, 25, 50, 100, 200, 500, 1000];
  const date_time_format = "D/M/Y HH:mm:ss A";
  const date_format = "D/M/Y";
  const time_format = "HH:mm:ss A";

  const APP_DOMAIN = process.env.REACT_APP_APP_DOMAIN;
  const WORKER_APP_DOMAIN = process.env.REACT_APP_WORKER_APP_DOMAIN;
  const APP_ENV = process.env.REACT_APP_APP_ENV;
  const DOMAINS = {
    admin: `administrator.${APP_DOMAIN}`,
    human: `human.${APP_DOMAIN}`,
    business: `business.${APP_DOMAIN}`,
    erm: `account.${APP_DOMAIN}`,
    assets: `assets.${APP_DOMAIN}`,
  };

  // const AUTH_URL = process.env.REACT_APP_AUTH_URL;
  // const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL;
  // const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;
  // const HUMAN_API_URL = process.env.REACT_APP_HUMAN_API_URL;

  var AUTH_URL = `http://localhost:3000`;
  var AUTH_API_URL = `http://127.0.0.1:8000/api`;
  var ADMIN_API_URL = `http://127.0.0.1:8001/api`;
  var HUMAN_API_URL = `http://127.0.0.1:8002/api`;
  var ERM_APP_URL = `http://localhost:3005`;
  var ASSETS_API_URL = `http://127.0.0.1:8008/api`;
  var ADMIN_URL = `http://localhost:3001`;
  var GWL_API_URL = `http://127.0.0.1:8015/api`;

  if (APP_ENV === "production") {
    AUTH_URL = `https://${APP_DOMAIN}`;
    AUTH_API_URL = `${AUTH_URL}/api`;
    ADMIN_API_URL = `https://administrator.${APP_DOMAIN}/api`;
    HUMAN_API_URL = `https://human.${APP_DOMAIN}/api`;
    ERM_APP_URL = `https://account.${APP_DOMAIN}`;
    ASSETS_API_URL = `https://assets.${APP_DOMAIN}/api`;
    ADMIN_URL = `https://administrator.${APP_DOMAIN}`;
    GWL_API_URL = `https://gwl.${WORKER_APP_DOMAIN}/api`;
  } else if (APP_ENV === "development") {
    AUTH_URL = `http://${APP_DOMAIN}`;
    AUTH_API_URL = `${AUTH_URL}/api`;
    ADMIN_API_URL = `http://administrator.${APP_DOMAIN}/api`;
    HUMAN_API_URL = `http://human.${APP_DOMAIN}/api`;
    ERM_APP_URL = `http://account.${APP_DOMAIN}`;
    ASSETS_API_URL = `http://assets.${APP_DOMAIN}/api`;
    ADMIN_URL = `http://administrator.${APP_DOMAIN}`;
    GWL_API_URL = `http://gwl.${WORKER_APP_DOMAIN}/api`;
  }

  const ROUTES_WITHOUT_AUTH = ["/join", "/unsubscribe", "/unsubscribed", "/register"];
  return {
    per_page,
    sql_date_format,
    AUTH_API_URL,
    AUTH_URL,
    ADMIN_API_URL,
    HUMAN_API_URL,
    ERM_APP_URL,
    ROUTES_WITHOUT_AUTH,
    DOMAINS,
    ASSETS_API_URL,
    ADMIN_URL,
    GWL_API_URL,
    items_per_page_options,
    date_time_format,
    date_format,
    time_format,
  };
};

export default useConstants;
